<template>
    <!-- Footer -->
    <footer class="footer bg-light">
           <loading :show="is_loading" :label="label"> </loading>
    </footer>
</template>

<script>
    import loading from 'vue-full-loading'
    import { mapState } from 'vuex'
    export default {
        name: "footerAdmin",
        data(){
               return {
                   show: this.is_loading,
                   label: 'Carregando...'
               }
           },
        components: { loading },
        computed: {
              ...mapState({ 'is_loading': state => state.is_loading, })
        }
    }
</script>

<style scoped>

</style>
